import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'
import { formatCurrencyAutoLocale } from '@/utils/tools'

const Audience = ({ audience, stage, color, store, currency, minDailyBudget }) => {
    const isSelected = store.isAudienceSelected(stage.id, audience.id)
    const audienceAmount = store.getAudienceAmount(stage.id, audience.id) || 0
    const hasError = isSelected && audienceAmount < minDailyBudget / 100
    const amount = isSelected ? audienceAmount : 0
    const formattedAmount = formatCurrencyAutoLocale({ amount, currency, showCode: true })

    const handleCheckboxChange = (audienceId) => store.toggleAudience(stage.id, audienceId)

    return (
        <Label
            key={audience.id}
            style={{ borderLeftColor: color }}
            htmlFor={`${stage.id}-${audience.id}`}
            className="tw:border-l-4 tw:hover:bg-gray-500 tw:flex tw:justify-between tw:group tw:px-5 tw:!inline-flex"
        >
            <div className="tw:py-4 tw:flex tw:gap-1.5 tw:items-center tw:justify-center">
                <Checkbox
                    id={`${stage.id}-${audience.id}`}
                    checked={isSelected}
                    onCheckedChange={() => handleCheckboxChange(audience.id)}
                />
                <span className="tw:text-sm tw:ml-1 tw:cursor-pointer">{audience.name}</span>
            </div>
            <div className="tw:flex tw:items-center tw:justify-center" onClick={(e) => e.preventDefault()}>
                <span className={cn('tw:text-sm', hasError && 'tw:text-red-300')}>{formattedAmount}</span>
            </div>
        </Label>
    )
}

const SelectionList = ({ stage, audiences, color, store, currency, minDailyBudget }) => {
    return (
        <div className="tw:flex tw:flex-col tw:border-t tw:border-b tw:divide-y">
            {audiences.map((audience) => (
                <Audience
                    stage={stage}
                    color={color}
                    store={store}
                    key={audience.id}
                    audience={audience}
                    currency={currency}
                    minDailyBudget={minDailyBudget}
                />
            ))}
        </div>
    )
}

export default SelectionList
